export default "__VITE_ASSET__70462f2a__"